/**
 * Created by geemultimedia on 7/05/15.
 */

window.ParsleyConfig = {
    errorClass: 'has-error',
    successClass: 'has-success',
    classHandler: function(ParsleyField) {
        return ParsleyField.$element.parents('.form-group div');
    },
    errorsContainer: function(ParsleyField) {
        return ParsleyField.$element.parents('.form-group div');
    },
    errorsWrapper: '<span class="help-block">',
    errorTemplate: '<div></div>'

};